import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import Alert from 'reactstrap/es/Alert';
import styled from 'styled-components';
import {AttributeDiv} from '../../../common/components/layout/InputCol';
import {CenteredP, TitleButton} from '../../../common/components/StyledComp';
import {ROLES} from '../../../common/constants';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import {GRAPHQL_MUTATION_ADD_RECEIPT_COMMENT} from './ReceiptDetailsReviewMerchant';

const FullTextArea = styled.textarea`
  width: 100%;
  padding: 10px;
`;

const RightCol = styled(Col)`
  text-align: right;
`;

const MargedCol = styled(Col)`
  margin-bottom: 10px;
`;

const TicketComments = ({t, receipt, currentUser}) => {
  const hasComment = receipt.comments.length > 0;
  const hasAnswer = receipt.comments.length > 1;
  const answer = hasAnswer ? receipt.comments[1].review : '';
  const {role} = currentUser;
  const isMerchant = role === ROLES.MERCHANT;
  const [editedAnswer, setEditedAnswer] = useState(answer);
  const variables = {
    receiptCommentInput: {
      receiptId: receipt.id,
      review: editedAnswer,
    },
  };

  return (
    <>
      <Col xs={12}>
        <label className="mandatory-label">
          <AttributeDiv className="label-name">{t('popinDetails.reviewUser')}</AttributeDiv>
        </label>
      </Col>
      <Col xs={12}>
        {
          !hasComment && <CenteredP>{t('noComment')}</CenteredP>
        }
      </Col>
      {hasComment && (
        <MargedCol xs={12}>
          <FullTextArea
            disabled
            value={hasComment ? receipt.comments[0].review : ''}
            rows={7}
          />
        </MargedCol>
      )}
      {((isMerchant && hasComment) || hasAnswer) && (
        <Col xs={12}>
          <label className="mandatory-label">
            <AttributeDiv className="label-name">{t('popinDetails.merchantResponse')}</AttributeDiv>
            <FullTextArea
              placeholder={t('typeAnswer')}
              disabled={!isMerchant || hasAnswer}
              value={editedAnswer}
              onChange={e => setEditedAnswer(e.target.value)}
              rows={7}
            />
          </label>
        </Col>
      )}
      {isMerchant && !hasAnswer && hasComment && (
        <Mutation mutation={GRAPHQL_MUTATION_ADD_RECEIPT_COMMENT} variables={variables}>
          {(mutation, {loading, error}) => {
            return (
              <RightCol xs={12}>
                {error && <Alert color="danger">{t('error')}</Alert>}
                <TitleButton
                  type="submit"
                  disabled={loading || !editedAnswer}
                  onClick={mutation}>
                  {t('popinDetails.sendResponse')}
                </TitleButton>
              </RightCol>
            );
          }}
        </Mutation>
      )}
    </>
  );
};

TicketComments.propTypes = {
  t: PropTypes.func.isRequired,
  receipt: PropTypes.shape({
    comments: PropTypes.array,
  }).isRequired,
};

export default withLoadedUser(withTranslation('ticket')(TicketComments));
